import Command from '../../core/Command';
import RegisterRequest from '../../core/RegisterRequest';
import ServerRequest from '../../core/ServerRequest';

export default {
  [Command.REGISTER_TOKEN]: (data) => new ServerRequest(1, new RegisterRequest(data)),
};
